import { useState, useEffect } from "react";

const useFormValidation = (formId) => {
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const form = document.getElementById(formId);
    const handleInputChange = () => {
      setIsValid(form.checkValidity());
    };

    if (form) {
      form.addEventListener("input", handleInputChange);

      return () => {
        form.removeEventListener("input", handleInputChange);
      };
    }
  }, [formId]);

  return isValid;
};

export default useFormValidation;
